import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import { SEZPDFTemplate } from "./SEZPDFTemplate";

const SEZPDF = ({ location }) => {
  const { state: { employee } = {} } = location;
  return (
    <Fragment>
      <Link
        className="py-5 my-5 ml-3 text-decoration-none"
        to="/SEZCandidateList"
      >
        Back to SEZ Candidate List
      </Link>
      <PDFViewer className="mt-3" width="100%" height="1000">
        <SEZPDFTemplate employee={employee} />
      </PDFViewer>
    </Fragment>
  );
};
export default SEZPDF;
